import { render } from "./ThePickupPoint.vue?vue&type=template&id=625147ec"
import script from "./ThePickupPoint.vue?vue&type=script&lang=js"
export * from "./ThePickupPoint.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__